import { type FunctionComponent } from 'react';
import { ACCOUNT_PRO_LINK } from '../../../constants/links';
import { useCustomer } from '../../../hooks/apollo/customer/customer.hooks';
import { StyledLink } from '../../common-components/link/styled-link.component';
import OmniProBadgeIconSvg from '../../svgs/omni-pro-badge-icon.svg';
import { proBadge } from './pro-signup-link.css';

export const ProSignupLink: FunctionComponent = () => {
	const { hasAccount } = useCustomer();
	return hasAccount ? null : (
		<StyledLink
			url={ACCOUNT_PRO_LINK}
			className={'dn flex-l flex-row items-center mr3 hover-theme-primary'}
			color="grey"
			underline={false}>
			<span className="f6 lh-copy" data-testid="omni-header-pro-signup">
				Are you a Pro?
			</span>
			<div className="f7 ml1">
				<span className="di v-mid">Get</span>
				<OmniProBadgeIconSvg className={`${proBadge} ph1 theme-pro di v-mid`} />
				<span className="di v-mid">Pricing</span>
			</div>
		</StyledLink>
	);
};
